import { useState } from 'react';
import {
  AppModal,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { UnmountClosed } from 'react-collapse/lib/UnmountClosed';
import { Formik } from 'formik';
import { ProgressBar } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../../Sidebar/AuxSidebar';
import colors from '../../../../../../constants/colors';
import { axiosPath } from '../../../../../../routing/helpers/router';
import ChangeBlockEvidence from './BlockChange/ChangeBlockEvidence';
import ChangeBlockCalendar from './BlockChange/ChangeBlockCalendar';
import Translator from '../../../../../components/helpers/Translator';
import minions from '../../../../../../minions/minions';
import UserSelectStates from '../../../../../components/form/Selects/UserSelectStates';
import ChangeBlockEvidenceClone from './BlockChange/ChangeBlockEvidenceClone';
import ChangeBlockResponsible from './BlockChange/ChangeBlockResponsible';
import errorHandler from '@/layout/components/error/ErrorHandler';

const BlockChangeSidebarBlock = () => {
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const obligationsCheckbox = useSelector(
    (state) => state.currentPage?.options?.obligationsCheckbox
  );
  const checkedPlantObligations = useSelector(
    (state) => state.currentPage?.checkedPlantObligations
  );
  const totalItemsCount = useSelector(
    (state) => state.currentPage?.pagination?.totalCount
  );
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions
  );
  const userBridgeSettings = useSelector(
    (s) => s.module?.[moduleBridgeHex]?.userBridge?.permissions
  );
  const [stateSection, setStateSection] = useState(false);
  const [probSevSection, setProbSevSection] = useState(false);
  const [evidenceSection, setEvidenceSection] = useState(false);
  const [calendarSection, setCalendarSection] = useState(false);
  const [responsibleSection, setResponsibleSection] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [blockChangePercent, setBlockChangePercent] = useState();

  const handleAuxSidebar = () => {
    if (auxSidebar !== 'blockChange')
      dispatch(
        currentPageAction.change('auxSidebar', { opened: 'blockChange' })
      );
    else dispatch(currentPageAction.change('auxSidebar', { opened: null }));
  };

  const handleCheckObligations = (value) => {
    dispatch(
      currentPageAction.change('options', { obligationsCheckbox: value })
    );
  };

  const handleBlockChange = async (values, isNew = true) => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_blockChange"),
        minions.forms.toFormData({
          ...values,
          evidenceFiles: values?.evidence?.files || null,
          plantHex,
          isNew,
          checkedPlantObligations: obligationsCheckbox
            ? checkedPlantObligations
            : [],
          filtersHex,
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((res) => {
        setBlockChangePercent(res.data.percent);
        if (res.data.isFinished) window.location.reload(false);
        else {
          setShowConfirmModal(false);
          handleBlockChange(values, false);
        }
      })
      .catch((err) => {
        if (err.response.status === 423) {
          alert(err.response.data);
          setShowConfirmModal(false);
        }
        dispatch(errorHandler(err));
      });
  };

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'blockChange' ? 'active' : ''}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="stack" />{' '}
          <span className="sb-title">
            <Translator file="module-legalCompliance" name="block.actions" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={
          <Translator file="module-legalCompliance" name="block.actions" />
        }
        isOpen={auxSidebar && auxSidebar === 'blockChange'}
        width="350px"
        position="right"
        onClose={() => handleAuxSidebar()}
      >
        {auxSidebar && auxSidebar === 'blockChange' && (
          <Formik
            initialValues={{
              state: null,
              probability: null,
              severity: null,
              evidence: null,
              evidenceClone: [],
              calendarEvent: null,
              addResponsibleIDs: [],
              deleteResponsibleIDs: [],
            }}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={(values) => handleBlockChange(values, true)}
          >
            {({ handleSubmit, values, setFieldValue, errors }) => (
              <div className="row">
                <div className="col-lg-12">
                  <p
                    className="text-justify pl-2 pr-2"
                    style={{ fontSize: '12px' }}
                  >
                    <Translator
                      file="module-legalCompliance"
                      name="block.actions.text.1"
                    />
                  </p>
                  <p
                    className="text-justify pl-2 pr-2 mt-2 mb-4"
                    style={{ fontSize: '12px' }}
                  >
                    <Translator
                      file="module-legalCompliance"
                      name="block.actions.text.2"
                      isHtml
                    />
                  </p>
                  {permissions.gcl?.module?.plant?.states?.blockChange &&
                    (!permissions.gcl?.module?.plant?.states?.blockChange
                      ?.allowedUsers ||
                      permissions.gcl?.module?.plant?.states?.blockChange
                        ?.allowedUsers.length === 0 ||
                      permissions.gcl?.module?.plant?.states?.blockChange?.allowedUsers.includes(
                        auth.user.id
                      )) &&
                    (userBridgeSettings?.level !== 2 ||
                      userBridgeSettings?.writeState === true) && (
                      <>
                        <BlockSection
                          onClick={() => setStateSection(!stateSection)}
                        >
                          <AppRemixIcon
                            icon={
                              stateSection ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="state.actions"
                          />
                        </BlockSection>
                        <UnmountClosed isOpened={stateSection}>
                          <>
                            <UserSelectStates
                              onHandleChange={(opt) =>
                                setFieldValue('state', opt)
                              }
                              hideObsolete
                              value={values?.state || null}
                              isMulti={false}
                              elements={
                                permissions.gcl?.module?.plant?.states
                                  ?.blockChange?.allowedStates &&
                                  permissions.gcl?.module?.plant?.states
                                    ?.blockChange?.allowedStates.length > 0
                                  ? {
                                    defaultStates:
                                      permissions.gcl?.module?.plant?.states
                                        ?.blockChange?.allowedStates,
                                    customStates: [],
                                  }
                                  : {
                                    defaultStates: 'all',
                                    customStates: 'all',
                                  }
                              }
                            />
                          </>
                        </UnmountClosed>
                      </>
                    )}
                  {permissions.gcl?.module?.plant?.probSevRisk
                    ?.probSevBlockChange &&
                    (userBridgeSettings?.level !== 2 ||
                      userBridgeSettings?.writeProvSev === true) &&
                    ((permissions.gcl?.module?.plant?.probSevRisk
                      ?.probability &&
                      permissions.gcl?.module?.plant?.probSevRisk
                        ?.probability !== 'wn') ||
                      (permissions.gcl?.module?.plant?.probSevRisk?.severity &&
                        permissions.gcl?.module?.plant?.probSevRisk
                          ?.severity !== 'wn')) && (
                      <>
                        <BlockSection
                          onClick={() => setProbSevSection(!probSevSection)}
                        >
                          <AppRemixIcon
                            icon={
                              probSevSection ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="probability.severity.actions"
                          />
                        </BlockSection>
                        <UnmountClosed isOpened={probSevSection}>
                          <>
                            {permissions.gcl?.module?.plant?.probSevRisk
                              ?.probability &&
                              permissions.gcl?.module?.plant?.probSevRisk
                                ?.probability !== 'wn' && (
                                <AppSingleSelect
                                  title={
                                    <Translator
                                      file="module-legalCompliance"
                                      name="new.probabiity"
                                    />
                                  }
                                  placeholder={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="select.to.modify"
                                    />
                                  )}
                                  icon={<AppRemixIcon icon="numbers" />}
                                  onChange={(o) =>
                                    setFieldValue('probability', o)
                                  }
                                  value={values.probability}
                                  options={[
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.0"
                                        />
                                      ),
                                      value: 0,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.1"
                                        />
                                      ),
                                      value: 1,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.2"
                                        />
                                      ),
                                      value: 2,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.3"
                                        />
                                      ),
                                      value: 3,
                                    },
                                  ]}
                                  isClearable
                                />
                              )}
                            {permissions.gcl?.module?.plant?.probSevRisk
                              ?.severity &&
                              permissions.gcl?.module?.plant?.probSevRisk
                                ?.severity !== 'wn' && (
                                <AppSingleSelect
                                  title={
                                    <Translator
                                      file="module-legalCompliance"
                                      name="new.severity"
                                    />
                                  }
                                  placeholder={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="select.to.modify"
                                    />
                                  )}
                                  icon={<AppRemixIcon icon="numbers" />}
                                  onChange={(o) => setFieldValue('severity', o)}
                                  value={values.severity}
                                  options={[
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.0"
                                        />
                                      ),
                                      value: 0,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.1"
                                        />
                                      ),
                                      value: 1,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.2"
                                        />
                                      ),
                                      value: 2,
                                    },
                                    {
                                      label: ReactDOMServer.renderToString(
                                        <Translator
                                          file="filter"
                                          name="filter.probability.3"
                                        />
                                      ),
                                      value: 3,
                                    },
                                  ]}
                                  isClearable
                                />
                              )}
                          </>
                        </UnmountClosed>
                      </>
                    )}
                  {permissions.gcl?.module?.plant?.evidences &&
                    (permissions.gcl?.module?.plant?.evidences?.blockChange ||
                      permissions.gcl?.module?.plant?.evidences
                        ?.cloneBlockChange) &&
                    (userBridgeSettings?.level !== 2 ||
                      userBridgeSettings?.evidences?.read === true) && (
                      <>
                        <BlockSection
                          onClick={() => setEvidenceSection(!evidenceSection)}
                        >
                          <AppRemixIcon
                            icon={
                              evidenceSection ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="evidences.actions"
                          />
                        </BlockSection>
                        <UnmountClosed isOpened={evidenceSection}>
                          {permissions.gcl?.module?.plant?.evidences
                            ?.blockChange && (
                              <ChangeBlockEvidence
                                handleAddEvidence={(ev) =>
                                  setFieldValue('evidence', ev)
                                }
                                value={values.evidence}
                              />
                            )}
                          {permissions.gcl?.module?.plant?.evidences
                            ?.blockChange &&
                            permissions.gcl?.module?.plant?.evidences
                              ?.cloneBlockChange && (
                              <Divider className="mt-2 mb-2" />
                            )}
                          {permissions.gcl?.module?.plant?.evidences
                            ?.cloneBlockChange && (
                              <ChangeBlockEvidenceClone
                                handleAddEvidence={(ev) =>
                                  setFieldValue('evidenceClone', ev)
                                }
                                value={values.evidenceClone}
                              />
                            )}
                        </UnmountClosed>
                      </>
                    )}
                  {permissions.gcl?.module?.plant?.calendar &&
                    permissions.gcl?.module?.plant?.calendar?.blockChange &&
                    (userBridgeSettings?.level !== 2 ||
                      userBridgeSettings?.writeCalendar === true) && (
                      <>
                        <BlockSection
                          onClick={() => setCalendarSection(!calendarSection)}
                        >
                          <AppRemixIcon
                            icon={
                              calendarSection ? 'arrow-down-s' : 'arrow-right-s'
                            }
                            filled
                          />

                          <Translator
                            file="module-legalCompliance"
                            name="calendar.actions"
                          />
                        </BlockSection>
                        <UnmountClosed isOpened={calendarSection}>
                          <ChangeBlockCalendar
                            handleAddCalendarEvent={(ev) =>
                              setFieldValue('calendarEvent', ev)
                            }
                            value={values.calendarEvent}
                          />
                        </UnmountClosed>
                      </>
                    )}
                  {permissions.gcl?.module?.plant?.gclResponsibles &&
                    permissions.gcl?.module?.plant?.gclResponsibles
                      ?.blockChange && (
                      <>
                        <BlockSection
                          onClick={() =>
                            setResponsibleSection(!responsibleSection)
                          }
                        >
                          <AppRemixIcon
                            icon={
                              responsibleSection
                                ? 'arrow-down-s'
                                : 'arrow-right-s'
                            }
                            filled
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="actions.of.responsible"
                          />
                        </BlockSection>
                        <UnmountClosed isOpened={responsibleSection}>
                          <ChangeBlockResponsible
                            handleAddResponsibleEvent={(ev) =>
                              setFieldValue('addResponsibleIDs', ev)
                            }
                            handleDeleteResponsibleEvent={(ev) =>
                              setFieldValue('deleteResponsibleIDs', ev)
                            }
                            values={values}
                          />
                        </UnmountClosed>
                      </>
                    )}
                  <SelectList className="mt-4">
                    <li onClick={() => handleCheckObligations(true)}>
                      <AppRemixIcon
                        icon={
                          obligationsCheckbox
                            ? 'record-circle'
                            : 'checkbox-blank-circle'
                        }
                        className="mr-2"
                        size={14}
                      />
                      <Translator
                        file="module-legalCompliance"
                        name="obligations.select"
                      />
                    </li>
                    <li onClick={() => handleCheckObligations(false)}>
                      <AppRemixIcon
                        icon={
                          !obligationsCheckbox
                            ? 'record-circle'
                            : 'checkbox-blank-circle'
                        }
                        className="mr-2"
                        size={14}
                      />
                      <Translator
                        file="module-legalCompliance"
                        name="apply.to.all"
                      />
                      <small className="ml-1">
                        (
                        <Translator
                          file="module-legalCompliance"
                          name="only.filtered"
                        />
                        )
                      </small>
                    </li>
                  </SelectList>
                  {(obligationsCheckbox &&
                    checkedPlantObligations.length === 0) ||
                    (values.state === null &&
                      values.probability === null &&
                      values.severity === null &&
                      values.evidence === null &&
                      (Array.isArray(values.evidenceClone) && values.evidenceClone.length === 0) &&
                      (Array.isArray(values.addResponsibleIDs) && values.addResponsibleIDs.length === 0) &&
                      (Array.isArray(values.deleteResponsibleIDs) && values.deleteResponsibleIDs.length === 0) &&
                      values.calendarEvent === null) ? (
                    <span
                      className="btn btn-block btn-primary disabled"
                      title={ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="select.at.least.an.obligation"
                        />
                      )}
                    >
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.blockChange.apply"
                      />
                    </span>
                  ) : (
                    <span
                      className="btn btn-block btn-primary"
                      onClick={() => setShowConfirmModal(true)}
                    >
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.blockChange.apply"
                      />
                    </span>
                  )}
                </div>
                <AppModal
                  show={showConfirmModal}
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="apply.block.actions"
                    />
                  )}
                  onClose={() => setShowConfirmModal(false)}
                  onConfirm={handleSubmit}
                  isConfirmBtn
                  isCancelBtn
                  confirmBtnText={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.confirm" />
                  )}
                  cancelBtnText={ReactDOMServer.renderToString(
                    <Translator file="user" name="user.cancel" />
                  )}
                  size="lg"
                >
                  <p>
                    <Translator
                      file="module-legalCompliance"
                      name="confirm.apply.changes"
                    />
                  </p>
                  <ul>
                    {values.state !== null && (
                      <li>
                        <Translator
                          file="module-legalCompliance"
                          name="change.state.to.state"
                          variables={{
                            state: !values.state.isCustom
                              ? ReactDOMServer.renderToString(
                                <Translator
                                  file="user"
                                  name={`user.obligations.state${values.state.id}`}
                                />
                              )
                              : auth?.customStates?.[values.state?.id]?.name,
                          }}
                          isHtml
                        />
                      </li>
                    )}
                    {values.probability !== null && (
                      <li>
                        <Translator
                          file="module-legalCompliance"
                          name="change.probability.to.probability"
                          variables={{
                            probability: ReactDOMServer.renderToString(
                              <Translator
                                file="filter"
                                name={`filter.probability.${values.probability}`}
                              />
                            ),
                          }}
                          isHtml
                        />
                      </li>
                    )}
                    {values.severity !== null && (
                      <li>
                        <Translator
                          file="module-legalCompliance"
                          name="change.severity.to.severity"
                          variables={{
                            severity: ReactDOMServer.renderToString(
                              <Translator
                                file="filter"
                                name={`filter.probability.${values.severity}`}
                              />
                            ),
                          }}
                          isHtml
                        />
                      </li>
                    )}
                    {values.evidence !== null && (
                      <li>
                        <Translator
                          file="module-legalCompliance"
                          name="add.new.evidence"
                        />
                      </li>
                    )}
                    {values.calendarEvent !== null && (
                      <li>
                        <Translator
                          file="module-legalCompliance"
                          name="add.new.calendar.event"
                        />
                      </li>
                    )}
                  </ul>
                  <p>
                    <Translator
                      file="module-legalCompliance"
                      name="change.apply.to.no.reversible"
                      variables={{
                        total: obligationsCheckbox
                          ? checkedPlantObligations.length
                          : totalItemsCount,
                      }}
                      isHtml
                    />
                  </p>
                  <p>
                    <Translator
                      file="module-legalCompliance"
                      name="block.actions.wait.minutes"
                    />
                  </p>
                  <b className="text-danger">
                    <Translator
                      file="module-legalCompliance"
                      name="no.close.until.finish"
                    />
                  </b>
                </AppModal>
                <AppModal
                  show={!!blockChangePercent}
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="doing.block.action"
                    />
                  )}
                >
                  <Translator
                    file="module-legalCompliance"
                    name="doing.block.action.please.no.close"
                  />
                  <ProgressBar
                    now={blockChangePercent}
                    label={`${blockChangePercent}%`}
                    animated
                  />
                </AppModal>
              </div>
            )}
          </Formik>
        )}
      </AuxSidebar>
    </>
  );
};
export default BlockChangeSidebarBlock;

const SelectList = styled.ul`
  list-style: none;
  li {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

const BlockSection = styled.div`
  color: ${colors.primary};
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
`;

const Divider = styled.div`
  background: ${colors.grey600};
  height: 1px;
  width: 100%;
`;
